export default "__VITE_ASSET__3hpKQIMZ__ 100w";